<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <b-navbar class="persistent-no-gutters">
          <b-col md="12" class="mx-auto persistent-no-gutters top-bar-b-col">
            <b-navbar class="no-gutters">
              <!-- Logo in center -->
              <b-navbar-brand class="top-logo-container" @click="backToMain">
                <img class="mx-auto top-logo" src="../assets/logo.png" alt="fair-logo"/>
              </b-navbar-brand>
              <!-- Left aligned items -->
              <b-navbar-nav>
                <b-nav-item class="left-nav-item" v-if="$store.state.token || hideLogin" lef href="#"
                            >
                  <b-button class="top-bar-search-btn" @click.stop="backToMain">
                    <font-awesome-icon icon="home" size="lg"/>
                    <span class="menu-text-under d-none d-md-block">{{ $t('common.home') }}</span>
                  </b-button>
                </b-nav-item>
                <b-nav-item class="left-nav-item" v-else href="#">
                  <b-button class="top-bar-search-btn" @click.stop="$emit('onSignInClicked')">
                    <font-awesome-icon icon="user-circle" size="lg" />
                    <span class="menu-text-under d-none d-md-block">{{ $t('login.login') }}</span>
                  </b-button>
                </b-nav-item>
              </b-navbar-nav>
              <!-- Right aligned nav items -->
              <b-navbar-nav class="ml-auto top-right">
                <b-nav-form v-if="!hideSearch">
                  <b-button class="top-bar-search-btn" @click.stop="showSearchView">
                    <font-awesome-icon icon="search" size="lg" />
                    <span class="menu-text-under d-none d-md-block">{{ $t('common.search') }}</span>
                  </b-button>
                </b-nav-form>
                <!--<b-nav-form>
                  <b-button class="top-bar-search-btn" @click.stop="showPrivacyPolicy">
                    <font-awesome-icon icon="info-circle" size="lg"  />
                    <span class="menu-text-under d-none d-md-block">{{ $t('privacy.title') }}</span>
                  </b-button>
                </b-nav-form>-->
                <b-nav-item-dropdown right no-caret  v-if="$store.state.token && isNotAdmin($store.state.user)">
                  <template v-slot:button-content>
                    <font-awesome-icon icon="bars"/>
                  </template>
                  <b-dropdown-item href="#" @click.stop="showUserCampaignView">
                    <!-- TODO - Show only if the user is involved in campaigns!!! -->
                    {{ $t('page.my_campaigns')}}
                  </b-dropdown-item>
                  <b-dropdown-item href="#" v-if="isOrganizationSuperUser($store.state.user)" @click.stop="showOrganizationCampaignView">
                    {{ $t('page.organization_campaigns')}}
                  </b-dropdown-item>
                  <b-dropdown-item href="#" v-if="isOrganizationSuperUser($store.state.user)" @click.stop="showTeamsView">
                    {{ $t('page.teams')}}
                  </b-dropdown-item>

                  <b-dropdown-divider/>

                  <b-dropdown-item href="#" @click.stop="showMyDonations">
                    {{ $t('common.my_donations')}}
                  </b-dropdown-item>
                  <b-dropdown-item href="#" @click.stop="showUserInfo">
                    {{ $t('common.user_account') }}
                  </b-dropdown-item>
                  <b-dropdown-item href="#" @click.stop="logout">
                    {{ $t('common.logout') }}
                  </b-dropdown-item>
                </b-nav-item-dropdown>
              </b-navbar-nav>
            </b-navbar>
          </b-col>
  </b-navbar>

</template>

<script>
    import {userHelper} from "../mixins/UserMixin";
    import {views} from "../mixins/ViewMixin";

    export default {
        name: "top-bar",
        mixins: [userHelper, views],
        props: {
            hideLogin: {
                type: Boolean,
                default() {
                    return false
                }
            },
            hideSearch: {
                type: Boolean,
                default() {
                    return false
                }
            }
        },
        data() {
            return {
                query: null,
                currentView: views.CAMPAIGNS_VIEW,
                menuText: this.$t('login.login')
            }
        },
        mounted() {
          this.menuText = this.getMenuText()
        },
        methods: {
            logout: function () {
                this.$store.commit('storeToken', null)
            },

            backToMain: function () {
                this.$router.push({name: 'main-view'})
            },

            showSearchView: function () {
                this.$router.push({name: 'search-view'})
            },

            showPrivacyPolicy: function () {
                this.$router.push({name: 'privacy-policy-view'})
            },

            showCampaignView: function () {
                if (!this.isSelectedView(views.CAMPAIGNS_VIEW)) {
                    this.$router.push({name: 'main-view'})
                }
            },

            showUserCampaignView: function () {
                if (!this.isSelectedView(views.MY_CAMPAIGN_VIEW)) {
                    this.$router.push({name: 'my-campaign-view'})
                }
            },

            showOrganizationCampaignView: function () {
                if (!this.isSelectedView(views.ORGANIZATION_CAMPAIGN_VIEW)) {
                    this.$router.push({name: 'organization-campaign-view'})
                }
            },

            showTeamsView: function () {
                if (!this.isSelectedView(views.TEAMS_VIEW)) {
                    this.$router.push({name: 'teams-view'})
                }
            },

            showMyDonations: function () {
                if (!this.isSelectedView(views.MY_DONATIONS_VIEW)) {
                    this.$router.push({name: 'my-donations-view'})
                }
            },

            showUserInfo: function () {
                if (!this.isSelectedView(views.USER_INFO_VIEW)) {
                    this.$router.push({name: 'user-info-view'})
                }
            },

            isSelectedView: function (view) {
                return view === this.currentView
            },

            getMenuText() {
                switch (this.currentView)  {
                    case views.CAMPAIGNS_VIEW: return this.$t('page.campaigns')
                    case views.MY_DONATIONS_VIEW: return this.$t('common.my_donations')
                    case views.ORGANIZATION_CAMPAIGN_VIEW: return this.$t('page.organization_campaigns')
                    case views.TEAMS_VIEW: return this.$t('page.teams')
                    case views.TEAM_INFO_VIEW: return this.$t('page.payment_info')
                    case views.MY_CAMPAIGN_VIEW: return this.$t('page.user_campaigns')
                    case views.USER_INFO_VIEW: return this.$t('common.user_account')
                }
                return ''
            }

        }
    }
</script>

<style scoped>

</style>
